import Error404PageConfig from './errors/404/Error404PageConfig';

const pagesConfigs = [Error404PageConfig];

export default pagesConfigs;
